<template>
    <div class="mask" @click="close">
       <div class="share-link-box" @click.stop="">
           <div class="title">
               <div class="title-icon">
                   <i class="iconfont iconlianjie"></i>
               </div>
               <div class="title-text">
                   分享链接
               </div>
           </div>
            <div class="bottom">
               <div class="left">
                   <div class="row">
                       <div class="link-box">
                           <input type="text" v-model="showUrl">
                       </div>
                       <div class="link-btn">
                           <button type="button"
                            v-clipboard:copy="showUrl" 
                            v-clipboard:success="onCopy" 
                            v-clipboard:error="onError">
                            复制链接
                        </button>
                       </div>
                   </div>
                   <!-- <div class="row">
                       <div class="code">提取码</div>
                       <div class="code-btn">tpqy</div>
                   </div> -->
                   <div class="row">
                       <div class="p">可以将链接分享至微信，邀请学生来上课</div>
                   </div>
               </div>
               <div class="right">
                   <div class="code-img">
                       <div id="qrcode"></div>
                   </div>
                   <div class="p">将二维码推荐给好友，扫一扫直接进入</div>
                   <div class="down-btn" @click="downloadImg">下载二维码</div>
               </div>
           </div>
       </div>
       </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
    name:'ShareLik',
    props:["url"],
    data:{
        baseShareLink : 'https://h5.class.bestmali.cn/#/pages/courseInfo/courseInfo?outchain=1&'
    },
    methods:{
        onCopy(e) {
            this.$Message['success']({
                background: true,
                content: '复制成功'
            });
        },
        onError(e) {
            console.log('error')
        },
        createCode(){
            console.log('createCode')
            var qrcode = new QRCode("qrcode", {
                text: this.showUrl,
                width: 128,
                height: 128,
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.H
            })
        },
        downloadImg(){
            var canvasElement = document.getElementById('qrcode').getElementsByTagName('canvas')[0]
            var MIME_TYPE = "image/png"
            var imgURL = canvasElement.toDataURL(MIME_TYPE)
            var dlLink = document.createElement('a')
            dlLink.download = 'codeImg'
            dlLink.href = imgURL
            dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':')
            document.body.appendChild(dlLink)
            dlLink.click()
            document.body.removeChild(dlLink)
        },
        close(){
            this.$emit('closeShareLink')
        }
    },
    computed:{
        showUrl(){
            setTimeout(()=>{
                this.createCode()
            },200)
            return 'https://h5.class.bestmali.cn/#/pages/courseInfo/courseInfo?outchain=1&' + this.url
        }
    }
}
</script>
<style scoped>
.mask{
    position:absolute;
    width:100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(72,89,111,0.4);
    z-index: 99;
}
.share-link-box{
    width:800px;
    background: #fff;
    margin:120px auto 0 auto;
    color:#fff;
    font-size: 18px;
}
.share-link-box .title{
    width:100%;
    height: 98px;
    color: #09AAFF;
    font-size: 20px;
    border-bottom: 1px solid #DCDCDC;
}
.share-link-box .bottom{
    display: flex;
    padding:28px 0 28px 19px;
    color: #333;
}
.share-link-box .bottom .left{
    border-right: 1px solid #DCDCDC;
}
.share-link-box .row{
    display: flex;
}
.share-link-box .row .link-box{
    width:400px;
    height:40px;
    border:2px solid rgba(220,220,220,1);
    border-radius:5px;
    padding:0 10px;
}
.share-link-box .row .link-btn{
    width:150px;
    height:40px;
    line-height: 40px;
    background:rgba(95,190,150,1);
    border-radius:5px;
    margin:0 20px 0 10px;
    font-size: 17px;
    color: #fff;
}
.share-link-box .row .code{
    margin-top: 26px;
    margin-right: 10px;
}
.share-link-box .row .code-btn{
    width:80px;
    height:40px;
    line-height: 40px;
    border:2px solid rgba(220,220,220,1);
    border-radius:5px;
    margin-top: 20px;
}
.share-link-box .row .p{
    color: #999;
    font-size: 16px;
    margin-top: 27px;
}
.share-link-box .right{
    text-align: center;
    font-size: 16px;
    flex: 1;
}
.share-link-box .right .code-img{
    display: inline-block;
    width:100px;
    height: 100px;
}
.share-link-box .right .code-img >>> img{
    width:100%;
    height: 100%;
}
.share-link-box .right .p{
    font-size: 16px;
    color: #999;
    width: 158px;
    margin: 10px 0 8px 23px;
}
.share-link-box .right .down-btn{
    display: inline-block;
    width:150px;
    height:40px;
    line-height: 40px;
    background:rgba(95,190,150,1);
    border-radius:5px;
    font-size: 16px;
    color: #fff;
}
</style>